import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import DeviceConfigWizardComponent from './components/device-config-wizard.component';
import { useMediaQuery, useTheme } from '@mui/material';
import { useDeviceSchemaApiHook } from '../shared/device-data-api.hook';
import { ApiClientStatusEnum } from '@lifepowr/components/src/utils/api-client';
import { SchemaLoadingFailureAlertBox } from '../shared/schema-failure-alert.component';

type DeviceConfigWizardDialogProps = {
  schemas?: any;
  isOpen: boolean;
  onClose: () => void;
  thing?: any;
  attributes?: any;
  settings?: any;
  configuration?: any;
  diffObj?: any;
};

export function DeviceConfigWizardDialog(props: DeviceConfigWizardDialogProps) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const { triggerDeviceSchema, deviceSchemaApiClientStatus } = useDeviceSchemaApiHook();
  const hasSchemaFetchingFailed = deviceSchemaApiClientStatus.clientStatus === ApiClientStatusEnum.Error;

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="lg"
      open={props.isOpen}
    >
      <DialogTitle>FlexiO Configuration</DialogTitle>
      <DialogContent sx={{ padding: fullScreen ? '0' : undefined }}>
        <Box>
          {hasSchemaFetchingFailed ? (
            <SchemaLoadingFailureAlertBox
              onRefresh={triggerDeviceSchema}
              onClose={props.onClose}
            />
          ) : (
            <DeviceConfigWizardComponent
              {...props}
              schemas={deviceSchemaApiClientStatus.data}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
